// source: v2/types/login.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_access_control_pb = require('../../v2/types/access_control_pb.js');
goog.object.extend(proto, v2_types_access_control_pb);
var v2_types_customer_pb = require('../../v2/types/customer_pb.js');
goog.object.extend(proto, v2_types_customer_pb);
var v2_types_login_authentication_method_pb = require('../../v2/types/login_authentication_method_pb.js');
goog.object.extend(proto, v2_types_login_authentication_method_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.Login', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.LoginActivationStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.LoginStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ScopeRoles', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Login = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.Login.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Login, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Login.displayName = 'proto.loopup.ctgateway.v2.Login';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ScopeRoles = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.ScopeRoles.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ScopeRoles, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ScopeRoles.displayName = 'proto.loopup.ctgateway.v2.ScopeRoles';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.Login.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Login.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Login.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Login} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Login.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    profilePictureUrl: (f = msg.getProfilePictureUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    createdAtTime: (f = msg.getCreatedAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAtTime: (f = msg.getUpdatedAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    accessControlMap: (f = msg.getAccessControlMap()) ? f.toObject(includeInstance, proto.loopup.ctgateway.v2.AccessControl.toObject) : [],
    customer: (f = msg.getCustomer()) && v2_types_customer_pb.Customer.toObject(includeInstance, f),
    activationStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    authenticationMethodsList: jspb.Message.toObjectList(msg.getAuthenticationMethodsList(),
    v2_types_login_authentication_method_pb.LoginAuthenticationMethod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Login}
 */
proto.loopup.ctgateway.v2.Login.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Login;
  return proto.loopup.ctgateway.v2.Login.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Login} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Login}
 */
proto.loopup.ctgateway.v2.Login.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfilePictureUrl(value);
      break;
    case 6:
      var value = /** @type {!proto.loopup.ctgateway.v2.LoginStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAtTime(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAtTime(value);
      break;
    case 9:
      var value = msg.getAccessControlMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.loopup.ctgateway.v2.AccessControl.deserializeBinaryFromReader, "", new proto.loopup.ctgateway.v2.AccessControl());
         });
      break;
    case 10:
      var value = new v2_types_customer_pb.Customer;
      reader.readMessage(value,v2_types_customer_pb.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 11:
      var value = /** @type {!proto.loopup.ctgateway.v2.LoginActivationStatus} */ (reader.readEnum());
      msg.setActivationStatus(value);
      break;
    case 12:
      var value = new v2_types_login_authentication_method_pb.LoginAuthenticationMethod;
      reader.readMessage(value,v2_types_login_authentication_method_pb.LoginAuthenticationMethod.deserializeBinaryFromReader);
      msg.addAuthenticationMethods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Login.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Login.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Login} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Login.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProfilePictureUrl();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCreatedAtTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAtTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccessControlMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.loopup.ctgateway.v2.AccessControl.serializeBinaryToWriter);
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      v2_types_customer_pb.Customer.serializeBinaryToWriter
    );
  }
  f = message.getActivationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getAuthenticationMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      v2_types_login_authentication_method_pb.LoginAuthenticationMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Login.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Login.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Login.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Login.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue profile_picture_url = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Login.prototype.getProfilePictureUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
*/
proto.loopup.ctgateway.v2.Login.prototype.setProfilePictureUrl = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearProfilePictureUrl = function() {
  return this.setProfilePictureUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Login.prototype.hasProfilePictureUrl = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional LoginStatus status = 6;
 * @return {!proto.loopup.ctgateway.v2.LoginStatus}
 */
proto.loopup.ctgateway.v2.Login.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.LoginStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.LoginStatus} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Login.prototype.getCreatedAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
*/
proto.loopup.ctgateway.v2.Login.prototype.setCreatedAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearCreatedAtTime = function() {
  return this.setCreatedAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Login.prototype.hasCreatedAtTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Login.prototype.getUpdatedAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
*/
proto.loopup.ctgateway.v2.Login.prototype.setUpdatedAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearUpdatedAtTime = function() {
  return this.setUpdatedAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Login.prototype.hasUpdatedAtTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * map<string, AccessControl> access_control = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.loopup.ctgateway.v2.AccessControl>}
 */
proto.loopup.ctgateway.v2.Login.prototype.getAccessControlMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.loopup.ctgateway.v2.AccessControl>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      proto.loopup.ctgateway.v2.AccessControl));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearAccessControlMap = function() {
  this.getAccessControlMap().clear();
  return this;};


/**
 * optional Customer customer = 10;
 * @return {?proto.loopup.ctgateway.v2.Customer}
 */
proto.loopup.ctgateway.v2.Login.prototype.getCustomer = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Customer} */ (
    jspb.Message.getWrapperField(this, v2_types_customer_pb.Customer, 10));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Customer|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
*/
proto.loopup.ctgateway.v2.Login.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Login.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional LoginActivationStatus activation_status = 11;
 * @return {!proto.loopup.ctgateway.v2.LoginActivationStatus}
 */
proto.loopup.ctgateway.v2.Login.prototype.getActivationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.LoginActivationStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.LoginActivationStatus} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.setActivationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * repeated LoginAuthenticationMethod authentication_methods = 12;
 * @return {!Array<!proto.loopup.ctgateway.v2.LoginAuthenticationMethod>}
 */
proto.loopup.ctgateway.v2.Login.prototype.getAuthenticationMethodsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.LoginAuthenticationMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_login_authentication_method_pb.LoginAuthenticationMethod, 12));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.LoginAuthenticationMethod>} value
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
*/
proto.loopup.ctgateway.v2.Login.prototype.setAuthenticationMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.LoginAuthenticationMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.LoginAuthenticationMethod}
 */
proto.loopup.ctgateway.v2.Login.prototype.addAuthenticationMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.loopup.ctgateway.v2.LoginAuthenticationMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.Login} returns this
 */
proto.loopup.ctgateway.v2.Login.prototype.clearAuthenticationMethodsList = function() {
  return this.setAuthenticationMethodsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.ScopeRoles.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ScopeRoles.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ScopeRoles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ScopeRoles.toObject = function(includeInstance, msg) {
  var f, obj = {
    scope: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles}
 */
proto.loopup.ctgateway.v2.ScopeRoles.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ScopeRoles;
  return proto.loopup.ctgateway.v2.ScopeRoles.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ScopeRoles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles}
 */
proto.loopup.ctgateway.v2.ScopeRoles.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ScopeRoles.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ScopeRoles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ScopeRoles.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string scope = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles} returns this
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string roles = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.getRolesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles} returns this
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles} returns this
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ScopeRoles} returns this
 */
proto.loopup.ctgateway.v2.ScopeRoles.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.LoginStatus = {
  LOGIN_STATUS_INVALID: 0,
  LOGIN_STATUS_ACTIVE: 1,
  LOGIN_STATUS_REVOKED: 2
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.LoginActivationStatus = {
  LOGIN_ACTIVATION_STATUS_INVALID: 0,
  LOGIN_ACTIVATION_STATUS_CREATED: 1,
  LOGIN_ACTIVATION_STATUS_INVITED: 2,
  LOGIN_ACTIVATION_STATUS_ACTIVATED: 3
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
